module.exports = __webpack_public_path__ + "img/Group.271b223f.svg";